import React, { useState, useEffect } from "react";
import { api } from "../../utils/api";
import { ChevronRight } from "lucide-react";

export default function ResidentLogin({ onLogin }) {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // Sayfa yüklendiğinde tarayıcı belleğinden kayıtlı telefon numarasını çek
  useEffect(() => {
    const savedPhone = localStorage.getItem("resident_phone");
    if (savedPhone) {
      setPhone(savedPhone);
      setRemember(true);
    }
  }, []);

  const submit = async e => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");
    try {
      // Arka yüzdeki (FastAPI) login rotanıza telefonu gönderiyoruz
      const res = await api.post("/resident/login", { phone, password });
      
      // Beni hatırla seçiliyse telefonu tarayıcıya kaydet, seçili değilse sil
      if (remember) {
        localStorage.setItem("resident_phone", phone);
      } else {
        localStorage.removeItem("resident_phone");
      }
      
      onLogin(res.data);
    } catch (x) {
      setErrorMsg(x.response?.data?.detail || "Giriş başarısız. Lütfen bilgilerinizi kontrol edin.");
      setLoading(false);
    }
  };

  return (
    <main className="login-shell" style={{background: "linear-gradient(180deg, #1e293b 0%, #0f172a 100%)", minHeight: "100vh", display: "flex"}}>
      <section className="login-form" style={{margin: "auto", background: "white", padding: "40px", borderRadius: "12px", width: "100%", maxWidth: "400px", boxShadow: "0 10px 25px rgba(0,0,0,0.2)"}}>
        <div className="form-inner">
          <h2 style={{color: "#333", marginBottom: "20px", textAlign: "center"}}>Sakin Girişi</h2>
          <form onSubmit={submit} style={{display: "flex", flexDirection: "column", gap: "15px"}}>
            <label style={{display: "flex", flexDirection: "column", gap: "5px", fontSize: "14px", fontWeight: "500", color: "#444"}}>
              Cep Telefonu
              <input 
                value={phone} 
                onChange={e => setPhone(e.target.value)} 
                type="tel" 
                placeholder="05XX..." 
                required 
                style={{padding: "10px", borderRadius: "6px", border: "1px solid #ccc"}}
              />
            </label>
            <label style={{display: "flex", flexDirection: "column", gap: "5px", fontSize: "14px", fontWeight: "500", color: "#444"}}>
              Şifre
              <input 
                value={password} 
                onChange={e => setPassword(e.target.value)} 
                type="password" 
                required 
                style={{padding: "10px", borderRadius: "6px", border: "1px solid #ccc"}}
              />
            </label>
            
            <label style={{display: "flex", alignItems: "center", gap: "8px", fontSize: "13px", color: "#555", cursor: "pointer"}}>
              <input 
                type="checkbox" 
                checked={remember} 
                onChange={e => setRemember(e.target.checked)} 
                style={{width: "16px", height: "16px"}} 
              />
              Beni Hatırla (Telefon Numaramı Kaydet)
            </label>

            {errorMsg && <div className="error" style={{color:"red", fontSize:"13px", background: "#fee2e2", padding: "10px", borderRadius: "6px"}}>{errorMsg}</div>}
            
            <button className="primary full" disabled={loading} style={{background: "#3b82f6", border: "none", padding: "12px", color: "white", borderRadius: "8px", cursor: "pointer", fontWeight: "bold", marginTop: "10px", display: "flex", justifyContent: "center", alignItems: "center", gap: "8px"}}>
              {loading ? "Giriş Yapılıyor..." : <>Giriş Yap <ChevronRight size={18}/></>}
            </button>
          </form>
        </div>
      </section>
    </main>
  );
}